import type { Stripe } from '@stripe/stripe-js';

let stripePromise: Promise<Stripe> | undefined;

// One instance per page, including React StrictMode's effect replays. The pure
// entry point only injects Stripe.js when checkout is approaching the viewport.
export function getStripe(): Promise<Stripe> {
  if (!stripePromise) {
    stripePromise = import('@stripe/stripe-js/pure')
      .then(({ loadStripe }) => {
        const key = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY;
        if (!key) throw new Error('Stripe publishable key missing');
        return loadStripe(key);
      })
      .then((stripe) => {
        if (!stripe) throw new Error('Stripe unavailable');
        return stripe;
      })
      .catch((error: unknown) => {
        stripePromise = undefined;
        throw error;
      });
  }
  return stripePromise;
}
